import { Component, Input, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { navItems } from '../../_nav';
import { AuthService } from '../../_services/auth-service';
import { Router } from '@angular/router';
import { CondominiumService } from '../../_services/condominium.service';
import { PanelGroupService } from '../../_services/panelgroup.service';
import { ModalDirective } from 'ngx-bootstrap';
import { ApiClientService } from '../../_services/swagger';


@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html',
  styleUrls: ['./default-layout.component.css']
})
export class DefaultLayoutComponent implements OnInit, AfterViewInit {

  @ViewChild('panelGroupModal') panelGroupModal: ModalDirective;

  public navItems;
  public navItemsDropdownlist;
  public lstNavItemsDropdownlistFilter: any[];
  public condominiumsFilter: any[];
  public sidebarMinimized = true;
  private changes: MutationObserver;
  public element: HTMLElement = document.body;
  public currentUser: any;
  public condominium: any;
  public token: string
  public condominiumSelect: string;
  public year: string;
  public panelGroupColor: string;
  public panelGroups: any[];

  constructor(private authService: AuthService, private router: Router,
    public condominiumService: CondominiumService,
    public panelGroupService: PanelGroupService,
    public _apiClient: ApiClientService) {
    const date = new Date();
    this.year = date.getFullYear().toString();

    this.changes = new MutationObserver((mutations) => {
      this.sidebarMinimized = document.body.classList.contains('sidebar-minimized');
    });

    this.changes.observe(<Element>this.element, {
      attributes: true
    });
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.condominium = JSON.parse(localStorage.getItem('condominium'));
    this.token = localStorage.getItem('token');
    this.condominiumSelect = this.condominium.name;
    this.navItems = this.getNavItems();
    this.navItemsDropdownlist = this.getNavItemsDropdownList();
    this.lstNavItemsDropdownlistFilter = this.navItemsDropdownlist;
    this.condominiumsFilter = this.currentUser.condominiums;

    // le pone el color al panelGroup
    this.panelGroupService.color$.subscribe(color => {
      this.panelGroupColor = color;
    });

  }

  ngOnInit() {
    this.getPanelGroup();
  }

  ngAfterViewInit() {
    // Colapsar todos los menús desplegables al cargar la página, existia un problema que aparecia el menu todo expandido de inicio
    setTimeout(() => {
      const dropdowns = Array.from(document.querySelectorAll('.sidebar .nav-dropdown.open'));
      dropdowns.forEach(dropdown => {
        dropdown.classList.remove('open');
      });
    }, 100);
  }

  getPanelGroup() {
    this.panelGroups = [];
    this._apiClient.panelgroup(this.token, this.condominium.id).subscribe(data => {
        this.panelGroups = data.body.data;
        this.panelGroupService.setColor(this.getPanelGroupColor());
    });
  }

  onChange(condominium) {

    if (condominium) {
      // ir de nuevo por la información ya que pudo cambiar
      this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
      this.condominium = this.currentUser.condominiums.find(o => o.name === condominium);
      this.condominiumSelect = condominium;
      // localStorage.setItem('condominium', JSON.stringify(this.condominium));
      // console.log("se cambia");
      // se llama al observador que se ha cambiado el condominio
      this.condominiumService.setCurrentCondominium(this.condominium);
      this.router.navigate(['']);
      this.navItems = this.getNavItems();
      this.navItemsDropdownlist = this.getNavItemsDropdownList();
      this.lstNavItemsDropdownlistFilter = this.navItemsDropdownlist;
    }
  }

  // Genera el menu conforme a los permisos
  getNavItems() {

    // solo aplicamos permisos cuando tenga rol el usuario
    if (this.condominium.idRol) {
      const navItemsCopy = JSON.parse(JSON.stringify(navItems));

      let items = navItemsCopy.filter(e => this.condominium.actions.includes(e.codeAction) ||
        e.url === '#');

      // recorrer elementos con hijos
      for (const item of items.filter(e => e.url === '#')) {
        const childrenAllowed = item.children.filter(e => this.condominium.actions.includes(e.codeAction));

        item.children = childrenAllowed;
        if (childrenAllowed.length === 0) {
          items = items.filter(e => e !== item);
        }
      }

      return items;
    }

    // si es null su permiso, se retorna el objeto original
    return navItems;
  }

  // Genera el menu del dropdownlist una vez ya esta generado el menu con los elementos permitidos
  getNavItemsDropdownList() {

    const items = [];
    for (const item of this.navItems) {
      if (item.children) {
        for (const child of item.children) {
          items.push(child);
        }
      } else {
        items.push(item);
      }
    }

    if (items.length > 0) {
      items.shift();
    }

    return items;

  }

  showPanelGroups() {
    if (this.condominium) {
      this.panelGroupModal.show();
      this.getPanelGroup();

    }
  }

  logout() {
    this.authService.logout();
    this.router.navigate(['']);
  }

  handleFilter(value) {
    this.lstNavItemsDropdownlistFilter = this.navItemsDropdownlist.filter((s) => s.name.toLowerCase().indexOf(value.toLowerCase()) !== -1);
  }

  handleFilterCondominium(value) {
    this.condominiumsFilter = this.currentUser.condominiums.filter((s) => s.name.toLowerCase().indexOf(value.toLowerCase()) !== -1);
  }

  changeDropdownList(url: string) {
    this.router.navigate([url]);
  }

  getPanelGroupColor() {
    let color = 'red'; // por defecto rojo
    if (this.panelGroups) {

      const panelsOnline = this.panelGroups.filter(panel => panel.online === true);

      if (panelsOnline.length === this.panelGroups.length) {
        color = 'green';
      } else if (panelsOnline.length > 0) { // si hay por lo menos un panel online
        color = '#FEDC3D'; // amarillo
      }
    }

    return color;

  }

}
